export default __webpack_public_path__ + "static/media/pt-logo-notifs.46554637.svg";